export default {"src":"/assets/turbo/4ee14c4a/universalat/_next/static/media/favicon.e116ed31.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};